import React, { useEffect, useState } from 'react';
import MainLayout from '../../layouts/MainLayout';
import '../../styles/CommuniCapture.css';

const CommuniCapture = () => {

  const [text, setText] = useState('');
    const [tableData, setTableData] = useState([]);
    const [jsonPrompt, setJsonPrompt] = useState('');
    const [analysisRows, setAnalysisRows] = useState(20); 
    const [actionMessage, setActionMessage] = useState('');
    const [fullGeneratedText, setFullGeneratedText] = useState('');

    const convertToTable = () => {
        const currentYear = new Date().getFullYear();
        const regex = /\[(\d{1,2}\/\d{1,2}), (\d{1,2}:\d{1,2} [APMapm]{2})\] (.+?): (.+)/g;
        const matches = [...text.matchAll(regex)];

        let lastDateTime = null; // Store the date and time of the last row

        const formattedData = matches.map((match, index) => {
            const dateParts = match[1].split('/');
            const month = parseInt(dateParts[0], 10);
            const day = parseInt(dateParts[1], 10);

            const date = new Date(currentYear, month - 1, day); 
            const time = match[2];

            if (isNaN(date.getTime())) {
                // Skip rows where date cannot be parsed
                return null;
            }

            let replyTime = null;
            if (lastDateTime) {
                const currentDateTime = new Date(`${date.toLocaleDateString()} ${time}`);
                const timeDiffInMinutes = (currentDateTime - lastDateTime) / (60 * 1000);

                const hours = Math.floor(timeDiffInMinutes / 60);
                const minutes = Math.floor(timeDiffInMinutes % 60);

                replyTime = `${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
            }

            lastDateTime = new Date(`${date.toLocaleDateString()} ${time}`);

            return {
                serialNumber: index + 1,
                date: date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
                day: date.toLocaleDateString('en-US', { weekday: 'short' }),
                time,
                name: match[3],
                message: match[4],
                replyTime,
            };
        }).filter(Boolean); 

        setTableData(formattedData);
    };

    const resetForm = () => {
        setText('');
        setTableData([]);
        setActionMessage('');
        setJsonPrompt('');
        setFullGeneratedText('');
    };

    const createPrompt = () => {
        const analysisPrompt = `Analyze the conversation and let me know the - 
      1. Context, 
      2. Intent, 
      3. Sentiment, 
      4. Issue, 
      5. Opportunity in English. 
      Output must be in less than 25 words for each.`;

        setJsonPrompt(JSON.stringify(tableData.slice(-analysisRows), null, 2));

        const csvRows = ['Serial Number,Date,Day,Time,Name,Message,Reply Time (hr:min)'];
        tableData.forEach((row) => {
            csvRows.push(
                `${row.serialNumber},${row.date},${row.day},${row.time},${row.name},${row.message},${row.replyTime !== null ? row.replyTime : '-'}`
            );
        });

        setFullGeneratedText(`${analysisPrompt}\n\n${csvRows.join('\n')}`);

        setActionMessage('Prompt and CSV data generated.');
    };

    const copyToClipboard = () => {
        navigator.clipboard.writeText(jsonPrompt);
        setActionMessage('JSON copied to clipboard!');
    };

    const askAI = () => {
        setActionMessage('Integration with ChatGPT will be implemented later. Asking AI...');
    };

    const saveToDatabase = () => {
        setActionMessage('Integration with Think5Whys Database will be implemented later. Saving to Database...');
    };

    const create5WhyAnalysis = () => {
        setActionMessage('Integration with ChatGPT for 5 Why Analysis will be implemented later. Creating 5 Why Analysis...');
    };

    const closeScreen = () => {
        setActionMessage('Closing screen...');
    };

    return (
      <MainLayout>
        <div><h3 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>CommuniCapture (WhatsApp)</h3></div>
        <div className="text-to-table-container text-white">
            <h1 className='text-white'>WhatsApp Text</h1>
            <p>Copy & Paste Text From Your WhatsApp Chat Below. After Input The Text Press the "Convert Into Table" Button. (Images are not allowed)</p>
            <textarea
                type="description" 
                name="description" 
                id="description"
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="Paste text here (max 4000 characters)"
                maxLength={4000}
                className="text-area"
                style={{ height: '500px', width: '600px' }}
            />

            <button onClick={convertToTable} className="convert-button">
                Convert Into Table
            </button>
            <button onClick={resetForm} className="reset-button">
                Reset
            </button>

            {tableData.length > 0 && (
                <>
                    <table className="result-table">
                        <thead>
                            <tr>
                                <th>Serial Number</th>
                                <th>Date</th>
                                <th>Day</th>
                                <th>Time</th>
                                <th>Name</th>
                                <th>Message</th>
                                <th>Reply Time (hr:min)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.map((row) => (
                                <tr key={row.serialNumber}>
                                    <td>{row.serialNumber}</td>
                                    <td>{row.date}</td>
                                    <td>{row.day}</td>
                                    <td>{row.time}</td>
                                    <td>{row.name}</td>
                                    <td>{row.message}</td>
                                    <td>{row.replyTime !== null ? row.replyTime : '-'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <button onClick={createPrompt} className="prompt-button">
                        Create Prompt
                    </button>
                    <button onClick={copyToClipboard} className="copy-button">
                        Copy JSON to Clipboard
                    </button>

                    <pre className="json-prompt">{fullGeneratedText}</pre>

                    <div className="button-container">
                        <button onClick={askAI} className="ai-button">
                            Ask AI
                        </button>
                        <button onClick={saveToDatabase} className="database-button">
                            Save to Think5Whys Database
                        </button>
                        <button onClick={create5WhyAnalysis} className="analysis-button">
                            Create 5 Why Analysis Statement
                        </button>
                    </div>

                    <textarea
                        value={actionMessage}
                        onChange={(e) => setActionMessage(e.target.value)}  
                        className="action-message editable-text-area"
                    />

                    <button onClick={closeScreen} className="close-button">
                        Close Screen
                    </button>
                </>
            )}
        </div>
        </MainLayout>  
    );
};

export default CommuniCapture